// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3Qw21","validationTips":"StatementDescriptor_validationTips__3-jAS"};